module.exports = __webpack_public_path__ + "img/E.8660b66c.png";